import { AgResourceLanguage } from '../types';
import { login as EnUsLogin } from '../en-us/login';

export const login: AgResourceLanguage['login'] = {
  ...EnUsLogin,
  header: 'Correo electrónico o contraseña incorrectos',
  description:
    'Asegúrate de que este es el mismo correo electrónico que utilizaste al realizar tu pedido o al crear tu cuenta.'
};
